import React from 'react'
import { Link } from 'react-router-dom';
import { FaAnglesRight } from "react-icons/fa6";
import { format } from 'date-fns';
import { openFile } from '../../utils/helper';

const Notification = ({notification}) => {
  const formattedDate = notification.created_at
  ? format(new Date(notification.created_at), 'MMM dd, yyyy')
  : 'Unknown Date';

  return (
    <div  key={notification.id} className={`${notification.id %2 === 0 ?'bg-gray-200':''} w-full flex justify-start items-center text-sm text-blue-500 `}>
      <li className='list-none w-full flex justify-start items-center py-3 gap-2'>
       <span><FaAnglesRight size={10}/></span><span className='text-nowrap'>
       {formattedDate}:</span> 
         <Link
          className="flex-grow text-left"
           onClick={() => openFile(notification.file_id)}
           > 
          {notification.title.length > 70 
            ? `${notification.title.substring(0, 70)}...`
            : notification.title}
         </Link>
      </li>
    </div>
  )
}

export {Notification};
